import { createReducer, on } from '@ngrx/store';
import * as unsignedUploadDocumentsActions from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/actions/unsigned-upload-document.actions';
import { ProfileUnsignedUploadedDocument } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/models/profile-unsigned-uploaded-document.model';

export interface UnsignedUploadDocumentState {
    documents: ProfileUnsignedUploadedDocument[] | null;
    progress: number | null;
    hasUnsignedFlowEnabled: boolean,
    candidateId: number | null 
}

const initialState: UnsignedUploadDocumentState = {
    documents: null,
    progress: null,
    hasUnsignedFlowEnabled: false,
    candidateId: null
};

export const unsignedUploadDocumentReducer = createReducer<UnsignedUploadDocumentState>(
    initialState,
    on(
        unsignedUploadDocumentsActions.loadUnsignedDocumentsSuccess,
        (state, action): UnsignedUploadDocumentState => ({
            ...state,
            documents: action.documents,
            progress: action.progress,
            hasUnsignedFlowEnabled: action.hasUnsignedFlowEnabled,
            candidateId: action.candidateId
        })
    ),
    on(
        unsignedUploadDocumentsActions.loadUnsignedDocumentsFail,
        (state): UnsignedUploadDocumentState => ({
            ...state,
            documents: null,
            progress: null,
            hasUnsignedFlowEnabled: false
        })
    ),
    on(
        unsignedUploadDocumentsActions.unloadUnsignedDocuments,
        (state): UnsignedUploadDocumentState => ({
            ...state,             
             documents: null,
             progress: null,
             hasUnsignedFlowEnabled: false
        })
    ) 
);
